import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { Col, Button, Drawer } from "antd";
import CustomList from "../../../components/List";
import ListItem from "../../../components/ListItem";
import CustomPagination from "../../../components/CustomPagination";
import {
  useConsultantFinancialStatus,
  useIncidents,
} from "../../../../hooks/useDataHooks";
import { useReportDateRange } from "../../../../hooks/useReportDateRange";
import { ArrowLeftOutlined } from "@ant-design/icons";

// const package_number = { xxl: 3, xl: 3, lg: 3, md: 3, sm: 0, xs: 0 };
const invoice_no = { xxl: 4, xl: 4, lg: 4, md: 4, sm: 4, xs: 4 };
const description = {
  xxl: 8,
  xl: 8,
  lg: 8,
  md: 8,
  sm: 8,
  xs: 8,
};
const remarks = {
  xxl: 8,
  xl: 8,
  lg: 8,
  md: 8,
  sm: 8,
  xs: 8,
};

const headerLayout = [
  // { ...package_number, header: "Package" },
  { ...invoice_no, header: "Invoice No" },
  { ...description, header: "Description" },
  { ...remarks, header: "Remarks" },
  //   { ...stepsTaken, header: "Steps Taken" },
];

/**
 *   invoice_no: finance.invoice_no,
          description: finance.description,
          remarks: finance.remarks,
 */

const CscFinancialStatus = ({procuringEntityId}) => {
  const { startDate, endDate } = useReportDateRange();
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(15);
  
  const { consultantFinancial, pagination, loading, error } = useConsultantFinancialStatus(
    procuringEntityId,
    startDate,
    endDate,
    currentPage,
    pageSize
  );

  const [activeItem, setActiveItem] = useState(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleRowClick = (item) => {
    setActiveItem(item);
    setVisible(true);
  };

  const handleCloseDrawer = () => {
    setVisible(false);
  };

  const handlePageChange = (page, size) => {
    setCurrentPage(page);
    setPageSize(size);
    setActiveItem(null);
  };

  return (
    <div className="prst-table">
      {error && (
        <div style={{ 
          margin: "16px 0", 
          padding: "16px", 
          backgroundColor: "#fff2f0", 
          border: "1px solid #ffccc7", 
          borderRadius: "6px",
          color: "#cf1322"
        }}>
          <strong>Error:</strong> Failed to load consultant financial status data. Please try again later.
        </div>
      )}
            
      {!loading && !error && consultantFinancial.length === 0 && (
        <div style={{ 
          margin: "16px 0", 
          padding: "16px", 
          backgroundColor: "#f6ffed", 
          border: "1px solid #b7eb8f", 
          borderRadius: "6px",
          color: "#389e0d",
          textAlign: "center"
        }}>
          <strong>No Data Available:</strong> No consultant financial status data found for the selected procuring entity and date range.
        </div>
      )}

      <p className="count">{`${pagination?.total || 0} Financial status`}</p>
      <CustomList
        itemName={` Financial status`}
        items={consultantFinancial}
        page={currentPage}
        itemCount={pagination?.total || 0}
        loading={loading}
        headerLayout={headerLayout}
        showToolbar={false}
        renderListItem={({ item }) => (
          <ListItem
            name={item?.invoice_no?.name || "c"}
            key={item.id}
            item={item}
            isPackage={false}
            onClick={() => handleRowClick(item)}
            style={{
              backgroundColor:
                activeItem?.id === item.id
                  ? "#f0f0f0"
                  : "transparent",
            }}
          >
            <Col 
              {...invoice_no} 
              className="contentEllipse"
              data-label="Invoice No"
            >
              {item?.invoice_no || "-"}
            </Col>

            <Col 
              {...description} 
              className="contentEllipse"
              data-label="Description"
            >
              {item?.description?.length > 40 ? item?.description.slice(0, 40) + "..." : item?.description || "-"}
            </Col>

            <Col 
              {...remarks} 
              className="contentEllipse"
              data-label="Remarks"
            >
              {item?.remarks?.length > 40 ? item?.remarks.slice(0, 40) + "..." : item?.remarks || "-"}
            </Col>
            <button 
              className="view-card-details" 
              onClick={() => handleRowClick(item)}
            >
              View Details
            </button>
          </ListItem>
        )}
      />

      <CustomPagination 
        pagination={pagination}
        onPageChange={handlePageChange}
        loading={loading}
      />

      {activeItem && (
        <Drawer
          title={`CSC Financial Status`}
          placement="right"
          closable={true}
          onClose={handleCloseDrawer}
          visible={visible}
          width={500}
        >
          <p>
            <strong>Invoice no:</strong> {activeItem?.invoice_no || "-"}
          </p>
          <p>
            <strong>Description:</strong> {activeItem?.description}
          </p>
          <p>
            <strong>Remarks:</strong> {activeItem?.remarks}
          </p>
        </Drawer>
      )}
    </div>
  );
};

export default CscFinancialStatus;
